/* global axios */
import ApiClient from './ApiClient';

class ScenariosAPI extends ApiClient {
  constructor() {
    super('scenarios', { accountScoped: true });
  }

  activate(id, payload = {}) {
    return axios.post(`${this.url}/${id}/activate`, payload);
  }

  pause(id, payload = {}) {
    return axios.post(`${this.url}/${id}/pause`, payload);
  }

  versions(id) {
    return axios.get(`${this.url}/${id}/versions`);
  }

  runs(id, params = {}) {
    return axios.get(`${this.url}/${id}/runs`, { params });
  }

  run(id, runId) {
    return axios.get(`${this.url}/${id}/runs/${runId}`);
  }

  publish(id, payload) {
    return axios.post(`${this.url}/${id}/publish`, payload);
  }

  restoreVersion(id, payload) {
    return axios.post(`${this.url}/${id}/restore_version`, payload);
  }

  discardDraft(id, payload) {
    return axios.post(`${this.url}/${id}/discard_draft`, payload);
  }

  nodeCatalog() {
    return axios.get(`${this.url}/node_catalog`);
  }

  conditionValues(payload) {
    return axios.post(`${this.url}/condition_values`, payload);
  }

  preview(id, payload) {
    return axios.post(`${this.url}/${id}/preview`, payload);
  }

  simulate(id, payload) {
    return axios.post(`${this.url}/${id}/simulate`, payload);
  }
}

export default new ScenariosAPI();
